// Placeholder pages for modules that don't yet have a real /admin/*
// listing surface. Disputes + Claims have moved to `./Disputes.tsx`;
// Complaints has moved to `./Complaints.tsx`. What's left is `NotFound`,
// which the router uses as the catch-all for unknown routes.

import { PageHeader } from '@drivecars/admin-ui';

interface StubProps {
  eyebrow: string;
  title: string;
  sub: string;
  /** PR number that brings this page online, e.g. '2.8'. */
  landsIn: string;
}

function Stub({ eyebrow, title, sub, landsIn }: StubProps) {
  return (
    <div className="space-y-6">
      <PageHeader eyebrow={eyebrow} title={title} sub={sub} />
      <div className="rounded-xl border border-dashed border-[color:var(--bo-line)] bg-white px-6 py-16 text-center">
        <div className="text-[12px] font-semibold uppercase tracking-[0.16em] text-[color:var(--bo-mute)]">
          Coming in PR {landsIn}
        </div>
        <h2 className="mt-2 text-[18px] font-semibold tracking-tight">
          {title} list view + actions
        </h2>
        <p className="mx-auto mt-2 max-w-md text-[13px] text-[color:var(--bo-mute)]">
          The listing endpoint is wired but the operational pipeline that produces
          rows (carrier integrations, dispute escalations, payout schedules) lands
          alongside this view.
        </p>
      </div>
    </div>
  );
}

export const NotFound = () => (
  <Stub
    eyebrow="404"
    title="Page not found"
    sub="The route you opened doesn't match a backoffice module."
    landsIn="—"
  />
);
